import { Skeleton } from '../Skeleton'

interface SkeletonGalleryProps {
  count?: number
}

// Mirrors `.st-gallery` masonry: `column-width: 240px; column-gap: 14px`.
// Each tile uses `.st-gi`-style chrome (3px ink border + shadow-sm) and a
// 4:3 aspect ratio so the column flow feels right.
export function SkeletonGallery({ count = 8 }: SkeletonGalleryProps) {
  return (
    <div style={{ columnWidth: 240, columnGap: 14 }}>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          style={{
            breakInside: 'avoid',
            marginBottom: 14,
            border: 'var(--border) solid var(--ink)',
            boxShadow: 'var(--shadow-sm)',
            background: 'var(--paper-2)',
            aspectRatio: '4 / 3'
          }}>
          <Skeleton.Box w="100%" h="100%" style={{ border: 'none' }} />
        </div>
      ))}
    </div>
  )
}
